import {ContactSection} from "../index.js";

export const pageSectionComponentMap = {
    'contact': ContactSection
}